import { useEffect, useState } from 'react';
import { api, type PublicMarket } from './api.js';

/**
 * The public figures, asked for once a minute at most however many screens
 * want them: the welcome's book and this line read the same answer.
 */
let last: { at: number; read: Promise<PublicMarket> } | null = null;
export function publicMarketShared(): Promise<PublicMarket> {
  if (last !== null && Date.now() - last.at < 60_000) return last.read;
  const read = api.publicMarket();
  last = { at: Date.now(), read };
  read.catch(() => {
    last = null;
  });
  return read;
}

/**
 * The one true line about rewards, as the server words it: the day's XGE
 * and how many people traded yesterday. Nothing when it cannot be read.
 */
export function useSharedLine(): string | null {
  const [line, setLine] = useState<string | null>(null);
  useEffect(() => {
    let gone = false;
    publicMarketShared()
      .then((m) => {
        if (!gone) setLine(m.rewards?.sharedLine ?? null);
      })
      .catch(() => undefined);
    return () => {
      gone = true;
    };
  }, []);
  return line;
}

export function SharedLine({ line, className }: { line: string | null; className?: string }) {
  if (line === null) return null;
  return (
    <p
      className={`shared-line${className === undefined ? '' : ` ${className}`}`}
      data-testid="shared-line"
    >
      {line}
    </p>
  );
}
